import { BodyLarge400, BodySmall500, TitleLarge500, TitleMedium500 } from '@nebula/global-styles';
import styled from 'styled-components';

export const Container = styled.div``;

export const ButtonGroup = styled.div`
  margin-bottom: 8px;
  display: flex;
  flex-direction: column;
  gap: 16px;

  @media ${({ theme }) => theme.media.tabletPortraitMin} {
    flex-direction: row;
    margin-bottom: 16px;
  }

  @media ${({ theme }) => theme.media.tabletLandscapeMin} {
    margin-top: 24px;
    gap: 24px;
  }
`;

export const ChoiceButton = styled.button`
  -webkit-appearance: none;
  appearance: none;
  background-color: #fff;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 16px;
  border: 2px solid ${({ theme }) => theme.color.ui.grey[30]};
  border-radius: 12px;
  cursor: pointer;
  font-family: 'Roboto', Arial, sans-serif;
  width: 100%;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;

  @media ${({ theme }) => theme.media.tabletPortraitMin} {
    flex: 1;
    width: auto;
  }

  &:hover {
    border-color: ${({ theme }) => theme.color.ui.grey[50]};
  }

  &:focus-visible {
    outline: none;
    box-shadow: 0 0 0 3px ${({ theme }) => theme.color.ui.blue[30]};
  }

  &:active {
    background-color: ${({ theme }) => theme.color.ui.grey[10]};
  }
`;

export const IconContainer = styled.div`
  border-radius: 8px;
  flex-shrink: 0;
`;

export const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  text-align: left;
  flex: 1;
`;

export const TimeLabel = styled.p`
  font-family: 'Roboto', Arial, sans-serif;
  font-size: 16px;
  font-weight: 500;
  color: ${({ theme }) => theme.color.ui.grey[100]};
  line-height: 24px;
  margin: 0;
`;

export const EndDescription = styled.p`
  font-family: 'Roboto', Arial, sans-serif;
  font-size: 14px;
  font-weight: 400;
  color: ${({ theme }) => theme.color.ui.grey[70]};
  line-height: 20px;
  margin: 0;
`;

export const StyledTitleLarge500 = styled(TitleLarge500)`
  margin-top: 0;
  margin-bottom: 0;
`;

export const InfoTitle = styled(BodySmall500)`
  font-size: 16px;
  line-height: 24px;
  font-weight: 400;
  margin-bottom: 8px;
`;

export const StyledBodyLarge400 = styled(BodyLarge400)`
  margin-top: 8px;
  margin-bottom: 24px;
  font-weight: 400;
  line-height: 24px;
`;

export const StyledTitleMedium500 = styled(TitleMedium500)`
  line-height: 32px;
  color: ${({ theme }) => theme.color.ui.grey[100]};
  margin-bottom: 8px;
  margin-top: 32px;
`